module.exports = __webpack_public_path__ + "static/media/Limanu.1deb7b3f.png";